// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math

import {
  ELegoGET,
  EDeepKitGET,
  EDeepKitGET_LegoInstance_2,
  EDeepKitGET_LegoInstance_11,
  EKitInstancePOSTResp,
  SyncWrapper,
  EDeepKitGET_KitInstance_9,
  EKiLiGET,
  ELegoInstancePOSTResp,
  ESkinnyKitGET,
  EUserOrgKitRecentGET,
  EForEachButtonGET,
  EForEachButtonPOSTResp,
  Body_create_lego_v1__org_id__legos_post,
  ESkinnyKitUserGET,
} from "../types/api-schema";
import {
  KitRunSchemaElement,
  ApiRequest,
  HttpMethod,
  InstanceSchemaElement,
  KitVisibility,
  ExecutionEnv,
} from "../types/general-flank-types";
import {
  pathRest,
  lfind,
  lfindIndex,
  pathChopLast,
  pathLength,
  ocopy,
  lcopy,
  pathLast,
  lInsertAt,
  lremoveAt,
  lenumerate,
  pathFirst,
  omerge,
  oset,
  pathPeekSecond,
  ovaluemap,
  lgroupBy,
  oitems,
  lot2o,
  oget,
  pathsJoin,
  pathSplit,
  lsort,
  lfirst,
  pyfalsey,
  odiffOldNew,
  pathJoin,
  pyCoalesce,
  oKeysToSnake,
  oKeysToCamel,
  pytruthy,
  okeys,
  lunique,
  okeymap,
  sReplaceFromObj,
  lappend,
  okeyfilter,
  isArray,
} from "../brains/flang";
import {
  bindFlatParamsToSchema,
  injectLegoSchemaIntoKitRunSchema,
  strToSchema,
  setSchemaValuesToDefaults,
  schemaToStr,
  replaceElementInSchema,
  trimDownSchema,
  strToRunrams,
  runramsToStr,
  initSchema,
  schemaToQueryString,
  schemaToExcelPreppedString,
  findAllItemsInElement,
  elementSetInSchema,
  unionSchema,
  setAllInSchemaSubtree,
  elementGetInSchema,
  getAllEmptyRequiredElements,
  pathToQueryParams,
  findAllKeysInElement,
} from "./params";
import { zz } from "../brains/malf";

/*

8888888b.           888                  88888888888                                  
888  "Y88b          888                      888                                      
888    888          888                      888                                      
888    888  8888b.  888888  8888b.           888  888  888 88888b.   .d88b.  .d8888b  
888    888     "88b 888        "88b          888  888  888 888 "88b d8P  Y8b 88K      
888    888 .d888888 888    .d888888          888  888  888 888  888 88888888 "Y8888b. 
888  .d88P 888  888 Y88b.  888  888          888  Y88b 888 888 d88P Y8b.          X88 
8888888P"  "Y888888  "Y888 "Y888888          888   "Y88888 88888P"   "Y8888   88888P' 
                                                       888 888                        
                                                  Y8b d88P 888                        
                                                   "Y88P"  888                        

*/

export type SkinnyKitDoll = {
  name: string;
  kitId: number;
  orgId: string;
  isLegoKit: boolean;
  //   isBookmarked: boolean | null;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  visibility: KitVisibility;
  ogKitId: number | null;
};
export type RecentKitDoll = {
  name: string;
  kitId: number;
  isLegoKit: boolean;
  source: string;
  uokId: string;
  lastViewed: string;
};

export type ForEachButtonDoll = EForEachButtonGET;

export type LegoDoll = {
  legoId: number;
  legoName: string; // coalesce(org_lego.override_name, lego.name)
  olId: string;
  legoDescription: string | null;
  directoryId: number | null;
  runOnStartup: boolean | null;
  runOnStartupValues: object | null;
  runCredsId: number;
  syncCredsId: number;
  cloudId: string;
  cloudName: string;
  kitRunSchema: KitRunSchemaElement[];
  warningTag: string;
  runButtonText: string;
  runningMessage: string;
  legoInstanceId: number;
  /*
    "schema" (group of params) consists of "elements" (individual params)
    schema: [element, element, {objectPropertySchemas: [element, element, element]}]

    legoSchemaElement (aka lego.paramSchema)       // what we sync, stuff we can determine
    instanceSchemaElement                          // settings that the user applies on top (e.g. isHidden, defaultValue)
    kitRunSchemaElement                            // "live" values that we throw away (the actual parameter value, whether it's valid, etc)
  */
  order: number | null;
  collapsedView: boolean;
  isHidden: boolean;
  apiImageUrl: string | null;
  // Angus: we need to populate this
  kiliId: string | null;
  forEachButtonsOnOutput: ForEachButtonDoll[] | null;
  forEachButtonsIsRecevier: ForEachButtonDoll[] | null;
  executable: string | null;
  executionEnv: string;
};

export type LegoDollUpdate = Partial<LegoDoll>;

export type KitDoll = {
  kitId: number;
  kitDolls: KitDoll[] | null;
  legoDolls: LegoDoll[] | null;
  kitInstanceId: number | string;
  anchorLegoId: number | null;
  order: number | null;
  visibility: KitVisibility;
  name: string;
  directoryId: number | null;
  isCopycatKit: boolean | null;
};

export type KitDollPlanOptions = {
  replaceParamQueryString?: boolean;
  setElementsToPropElements?: boolean;
  greenToastOnSuccess?: string;
  redToastOnFailure?: string;
};
export class KitDollPlan {
  kitDoll: KitDoll | null;
  parallelRequests: ApiRequest[] | null;
  kitDollRequest: ApiRequest | null;
  options: KitDollPlanOptions;
  constructor({
    kitDoll = null,
    parallelRequests = null,
    kitDollRequest = null,
    options = {},
  }: {
    kitDoll?: KitDoll | null;
    parallelRequests?: ApiRequest[] | null;
    kitDollRequest?: ApiRequest | null;
    options?: KitDollPlanOptions;
  } = {}) {
    this.kitDoll = kitDoll;
    this.parallelRequests = parallelRequests;
    this.options = options;
    this.kitDollRequest = kitDollRequest;
  }
  addOptions(o: KitDollPlanOptions) {
    this.options = omerge(this.options, o);
    return this;
  }
}

export interface LegoInstanceMergedWithKiliId
  extends EDeepKitGET_LegoInstance_2 {
  kiliId: string | null;
  kiliSchema: string | null;
  kiliForEachButtons: EForEachButtonGET[] | null; // these are the buttons that are on the output of the lego (where this lego is the sender)
  kiliForEachButtonsIsReceiver: EForEachButtonGET[] | null; // these are the buttons where the lego is the sender
}

/*

8888888          d8b 888    d8b          888 d8b                   
  888            Y8P 888    Y8P          888 Y8P                   
  888                888                 888                       
  888   88888b.  888 888888 888  8888b.  888 888 88888888  .d88b.  
  888   888 "88b 888 888    888     "88b 888 888    d88P  d8P  Y8b 
  888   888  888 888 888    888 .d888888 888 888   d88P   88888888 
  888   888  888 888 Y88b.  888 888  888 888 888  d88P    Y8b.     
8888888 888  888 888  "Y888 888 "Y888888 888 888 88888888  "Y8888  
                                                                   
                                                                   
                                                                   

*/
function _planToCreateKit(kd: KitDoll): void {
  return;
}
function _initParamSchema(
  legoSchema: string,
  instanceParamSchema: string,
  kiliParamSchema: string | null
) {
  let ips: string = instanceParamSchema;
  if (ips === null) {
    ips = schemaToStr(
      // in the case of kits that are legos, the instanceParamSchema is not
      // initialized by the sync'ing process, so we initialize it here
      // (this is a hack to avoid doing this work on the backend, when
      // add a lego for the first time through sync'ing)
      initSchema(strToSchema(legoSchema), {
        from: "lego",
        to: "instance",
      })
    );
  }
  if (pytruthy(kiliParamSchema)) {
    console.log("LAYER ON KILIPARAMSCHEMA");
    const kiliUnionedWithInstance = initSchema(
      unionSchema(
        strToSchema(ips) as InstanceSchemaElement[],
        strToSchema(kiliParamSchema as string) as InstanceSchemaElement[]
      ),
      {
        from: "instance",
        to: "kitrun",
      }
    );
    return kiliUnionedWithInstance;
  } else {
    const justInstanceSchema = initSchema(strToSchema(ips as string), {
      from: "instance",
      to: "kitrun",
    });
    return justInstanceSchema;
  }
}

function _initLegoDoll(
  instance:
    | EDeepKitGET_LegoInstance_2
    | EDeepKitGET_LegoInstance_11
    | LegoInstanceMergedWithKiliId,
  kitInstanceId: number | string,
  createFromPOST: ELegoInstancePOSTResp | null = null
): LegoDoll {
  let kitRunSchema = _initParamSchema(
    instance.ol.lego.paramSchema,
    createFromPOST?.instanceParamSchema ?? instance.instanceParamSchema,
    "kiliSchema" in instance ? instance.kiliSchema : null
  ) as KitRunSchemaElement[];

  if (kitInstanceId !== "root") {
    // the paramSender path is insufficient when it gets added to a KingKit
    // for example, if it's root.li_123 in a LegoKit, and then it's added
    // to a KingKing under ki 456, then the path needs to be updated to root.ki_456.li_123
    kitRunSchema = _setLKParamSenderPathToKKPath(
      kitRunSchema,
      kitInstanceId as number
    );
  }
  console.log("INSTANCE", instance);
  return {
    legoId: createFromPOST?.legoId ?? instance.legoId,
    olId: createFromPOST?.olId ?? instance.olId,
    order: createFromPOST?.order ?? instance.order,
    legoInstanceId: createFromPOST?.legoInstanceId ?? instance.legoInstanceId,
    kitRunSchema: kitRunSchema,
    legoName: pyCoalesce(instance?.ol.overrideName, instance.ol.lego.name),
    legoDescription: instance.ol.description,
    //@ts-ignore
    directoryId: instance.kit.directoryId,
    runOnStartup: instance.ol.runOnStartup,
    runOnStartupValues: strToRunrams(instance.ol.runOnStartupValues),
    runCredsId: instance.ol.runCredsId,
    syncCredsId: instance.ol.syncCredsId,
    cloudId: instance.ol.lego.cloudId,
    cloudName: instance.ol.lego.name,
    warningTag: instance.ol.warningTag,
    runButtonText: instance.ol.runButtonText,
    runningMessage: instance.ol.runningMessage,
    collapsedView: false,
    //@ts-ignore
    isHidden: pytruthy(instance.kiliForEachButtonsIsReceiver),
    apiImageUrl: instance.ol.runCreds?.resource?.api?.imageUrl ?? null,
    //@ts-ignore
    kiliId: instance.kiliId ?? null,
    //@ts-ignore
    forEachButtonsOnOutput: instance.kiliForEachButtons ?? null,
    //@ts-ignore
    forEachButtonsIsRecevier: instance.kiliForEachButtonsIsReceiver ?? null,
    executable: instance.ol.lego.executable,
    executionEnv: instance.ol.lego.executionEnv as ExecutionEnv,
  };
}
function _initLegoDollList(
  legoInstances:
    | EDeepKitGET_LegoInstance_11[]
    | LegoInstanceMergedWithKiliId[]
    | EDeepKitGET_LegoInstance_2[],
  kitInstanceId: number | string
): LegoDoll[] {
  //@ts-ignore
  const unorderedLegoInstances: LegoDoll[] = legoInstances.map(
    (
      instance:
        | EDeepKitGET_LegoInstance_2
        | EDeepKitGET_LegoInstance_11
        | LegoInstanceMergedWithKiliId
    ) => {
      return _initLegoDoll(instance, kitInstanceId);
    }
  );
  return lsort(unorderedLegoInstances, "order");
}

function _isEDeepKitGETSingleLegoKit(deepKit: EDeepKitGET): boolean {
  return (
    deepKit.anchorLegoId !== null &&
    pyfalsey(deepKit.kitInstances) &&
    !pyfalsey(deepKit.legoInstances)
  );
}
function _initKitDoll(
  deepKit: EDeepKitGET,
  kitInstanceId: number | null = null,
  order: number | null = null
): KitDoll {
  console.log("deepKit:", deepKit);
  if (_isEDeepKitGETSingleLegoKit(deepKit)) {
    //@ts-ignore
    const legoInstancesWithKiliInfo: LegoInstanceMergedWithKiliId[] = deepKit.legoInstances.map(
      (li: EDeepKitGET_LegoInstance_2) => {
        return omerge(li, {
          kiliId:
            kitInstanceId !== null
              ? `${kitInstanceId}_${li.legoInstanceId}`
              : null,
          kiliSchema: null,
        });
      }
    );
    const kiid = kitInstanceId ?? "root";
    return {
      kitId: deepKit.kitId,
      kitDolls: null,
      legoDolls: _initLegoDollList(legoInstancesWithKiliInfo, kiid),
      kitInstanceId: kiid,
      anchorLegoId: deepKit.anchorLegoId,
      order: order ?? 0,
      name: deepKit.name,
      visibility: deepKit.visibility as KitVisibility,
      directoryId: deepKit.directoryId,
      isCopycatKit: pytruthy(deepKit?.ogKitId) ? true : false,
    };
  } else {
    console.log("NOT SINGLE LEGO KIT");
    const unorderedKitInstances = deepKit.kitInstances.map(
      (ki: EDeepKitGET_KitInstance_9) => {
        //@ts-ignore
        const legoInstances = ki.kilis.map((kili: EKiLiGET) => {
          console.log("KILI", kili);
          return omerge(kili.legoInstance, {
            kiliId: kili.kiliId,
            kiliSchema: kili.kiliSchema,
            kiliForEachButtons: kili.receiverButtons,
            kiliForEachButtonsIsReceiver: kili.senderButtons,
          });
        });
        return {
          kitId: ki.childKit.kitId,
          kitDolls: null,
          //@ts-ignore
          legoDolls: _initLegoDollList(legoInstances, ki.kitInstanceId),
          kitInstanceId: ki.kitInstanceId,
          anchorLegoId: ki.childKit.anchorLegoId,
          order: ki.order,
          name: ki.childKit.name,
          visibility: ki.childKit.visibility as KitVisibility,
          directoryId: ki.childKit.directoryId,
        };
      }
    );
    return {
      kitId: deepKit.kitId,
      kitDolls: lsort(unorderedKitInstances, "order"),
      legoDolls: null,
      kitInstanceId: kitInstanceId ?? "root",
      anchorLegoId: null,
      order: order ?? 0,
      name: deepKit.name,
      visibility: deepKit.visibility as KitVisibility,
      directoryId: deepKit.directoryId,
      isCopycatKit: pytruthy(deepKit?.ogKitId) ? true : false,
    };
  }
}

// const deep = {};
// _initKitDoll(oKeysToCamel(deep)); //=
function _initRecentKitDoll(r: EUserOrgKitRecentGET): RecentKitDoll {
  return {
    name: r.name,
    kitId: r.kitId,
    isLegoKit: r.anchorOl !== null,
    source: r.source,
    uokId: r.uokId,
    lastViewed: r.lastViewed,
  };
}

function _initRecentKitDolls(list: EUserOrgKitRecentGET[]): RecentKitDoll[] {
  const listCopied = lcopy(list);
  const recentsFiltered = listCopied.filter((recent: any) => !recent.isHidden);
  return recentsFiltered.map(_initRecentKitDoll);
}

function _initSkinnyKit(
  skinny: ESkinnyKitGET | ESkinnyKitUserGET
): SkinnyKitDoll {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    orgId: skinny.orgId,
    isLegoKit: skinny.anchorLegoId !== null,
    // isBookmarked: null,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.lego?.name ?? null,
    visibility: skinny.visibility as KitVisibility,
    ogKitId: skinny.ogKitId ?? null,
  };
}

function _initSkinnyKits(
  skinnyKits: (ESkinnyKitGET | ESkinnyKitUserGET)[]
): SkinnyKitDoll[] {
  return skinnyKits.map(_initSkinnyKit);
}
/*




8888888b.          888    888      
888   Y88b         888    888      
888    888         888    888      
888   d88P 8888b.  888888 88888b.  
8888888P"     "88b 888    888 "88b 
888       .d888888 888    888  888 
888       888  888 Y88b.  888  888 
888       "Y888888  "Y888 888  888 
                                   
                                   
                                   

*/
function _isLeaf(pathPart: string | null) {
  if (pathPart === null) return false;
  return pathPart.startsWith("li_");
}
function _isDollLeaf(doll: KitDoll | LegoDoll | null): boolean {
  if (doll === null) return false;
  return _isLeaf(_dollToPathPart(doll));
}
function _isBranch(pathPart: string | null) {
  if (pathPart === null) return false;
  if (pathPart === "root") return true;
  return pathPart.startsWith("ki_");
}
function _idEquals(pathPart: string, id: string | number): boolean {
  if (pathPart == "root") return "root" == id;
  return pathPart.split("_")[1] == id.toString();
}
function _dollToPathPart(node: KitDoll | LegoDoll | null): string {
  if (node === null) return "";
  if ("kitInstanceId" in node) {
    if (node.kitInstanceId == "root") {
      return "root";
    } else {
      return `ki_${node.kitInstanceId}`;
    }
  } else if ("legoInstanceId" in node) {
    return `li_${node.legoInstanceId}`;
  }
  return "";
}

// _dollToPathPart({ kitInstanceId: "root" }); //= // root
// _dollToPathPart({ kitInstanceId: 1234 }); //= // ki_1234
// _dollToPathPart({ legoInstanceId: 1234 }); //= // li_1234
// _dollToPathPart({ other: 1234 }); //= // ''

function _pathPartToId(pathPart: string): string | number {
  if (pathPart == "root") return "root";
  return pathPart.split("_")[1];
}
// _pathPartToId("root"); //= // root
// _pathPartToId("ki_123"); //= // 123
// _pathPartToId("li_123"); //= // 123

function _kiliIdToPath(kiliId: string): string {
  const ids_split = kiliId.split("_");
  return `root.ki_${ids_split[0]}.li_${ids_split[1]}`;
}

// _kiliIdToPath("456_123"); //=
function _isLegoKit(kd: KitDoll) {
  return (
    kd.anchorLegoId !== null && pyfalsey(kd.kitDolls) && kd.legoDolls !== null
  );
}
function _rootIsLegoKit(kd: KitDoll) {
  return kd.kitInstanceId === "root" && _isLegoKit(kd);
}
// _isLegoKit({ kitInstanceId: "root", anchorLegoId: 123 }); //= // false
// _isLegoKit({ kitInstanceId: "root", anchorLegoId: 123, legoDolls: [] }); //= // false
// _isLegoKit({
//   kitInstanceId: "root",
//   anchorLegoId: 123,
//   legoDolls: [{ legoInstanceId: 1 }],
// }); //= // true
// _isLegoKit({
//   kitInstanceId: "root",
//   anchorLegoId: 123,
//   legoDolls: [{ legoInstanceId: 1 }],
// }); //= // true
// _isLegoKit({
//   kitInstanceId: "root",
//   anchorLegoId: 123,
//   legoDolls: null,
//   kitDolls: [{kitInstanceId: 1, legoDolls: [{legoInstanceId: 1}]}]
// }); //= // false

function isKingKitPath(path: string): boolean {
  if (path === "") return false;
  return _isBranch(pathPeekSecond(path));
}
// isKingKitPath("root.li_123"); //= false
// isKingKitPath("root.ki_123.li_456"); //= true

function _updateLKPathToKKPath(lkPath: string, kitInstanceId: number): string {
  if (lkPath === "") return "";
  else if (isKingKitPath(lkPath)) return lkPath;
  return pathsJoin(...lInsertAt(pathSplit(lkPath), 1, `ki_${kitInstanceId}`));
}

// _updateLKPathToKKPath("root.li_123", 456); //=
// _updateLKPathToKKPath("", 456); //=

function _createCallbackToUpdateLKPathToKKPath(
  kitInstanceId: number
): (e: KitRunSchemaElement) => any {
  const callback = (e: KitRunSchemaElement) => {
    return oset(
      e.paramSender,
      "path",
      _updateLKPathToKKPath(oget(e.paramSender, "path", ""), kitInstanceId)
    );
  };
  return callback;
}
function _setLKParamSenderPathToKKPath(
  schema: KitRunSchemaElement[],
  kitInstanceId: number
) {
  return setAllInSchemaSubtree(
    schema,
    "paramSender",
    _createCallbackToUpdateLKPathToKKPath(kitInstanceId)
  ); //=
}
// _setLKParamSenderPathToKKPath(
//   [{ key: "hi", paramSender: { path: "root.li_123", uiType: "dropdown" } }],
//   456
// ); //=
function _kdLdToPath(kd: KitDoll, ld: LegoDoll) {
  return `${
    kd.kitInstanceId === "root" ? "root" : `root.ki_${kd.kitInstanceId}`
  }.li_${ld.legoInstanceId}`;
}
/*



8888888b.                        888          
888   Y88b                       888          
888    888                       888          
888   d88P .d88b.   8888b.   .d88888 .d8888b  
8888888P" d8P  Y8b     "88b d88" 888 88K      
888 T88b  88888888 .d888888 888  888 "Y8888b. 
888  T88b Y8b.     888  888 Y88b 888      X88 
888   T88b "Y8888  "Y888888  "Y88888  88888P' 
                                              


                                              
                                              
*/
function _getLego(kd: KitDoll, path: string, makeCopy = true): LegoDoll | null {
  return _get(kd, path, makeCopy) as LegoDoll | null;
}
function _getKit(kd: KitDoll, path: string): KitDoll | null {
  return _get(kd, path, false) as KitDoll | null;
}
function _get(
  kd: KitDoll,
  path: string,
  makeCopy = true
): KitDoll | LegoDoll | null {
  if (
    _isBranch(pathFirst(path)) &&
    _isLeaf(pathPeekSecond(path)) &&
    _idEquals(pathFirst(path), kd.kitInstanceId)
  ) {
    return lfind(
      kd.legoDolls ?? [],
      (l) => _idEquals(pathRest(path), l.legoInstanceId),
      null,
      makeCopy // makes copy
    ) as LegoDoll | null;
  } else if (
    pathLength(path) === 1 &&
    _idEquals(pathFirst(path), kd.kitInstanceId)
  ) {
    return (makeCopy ? ocopy(kd) : kd) as KitDoll;
  } else if (_idEquals(pathFirst(path), kd.kitInstanceId)) {
    for (const k of kd.kitDolls ?? []) {
      const found = _get(k, pathRest(path), makeCopy);
      if (found) {
        return found;
      }
    }
  }
  return null;
}
// _get({ kitInstanceId: "root" }, ""); //=
// _get({ kitInstanceId: "root" }, "root"); //=
// _get({ kitInstanceId: "nada" }, "root"); //=
// _get(
//   { kitInstanceId: "root", kitDolls: [{ kitInstanceId: 456 }] },
//   "root.ki_456"
// ); //=
// _get(
//   { kitInstanceId: "root", kitDolls: [{ kitInstanceId: 456 }] },
//   "root.ki_456"
// ); //=
// _get(
//   { kitInstanceId: "root", kitDolls: [{ kitInstanceId: 456 }] },
//   "root.li_456"
// ); //=
// _get(
//   { kitInstanceId: "root", legoDolls: [{ legoInstanceId: 456 }] },
//   "root.li_456"
// ); //=
// _get(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       { legoDolls: [], kitInstanceId: 987 },
//       { legoDolls: [{ legoInstanceId: 456 }], kitInstanceId: 123 },
//     ],
//   },
//   "root.ki_123.li_456"
// ); //=

function _getKitDollsForRender(kd: KitDoll): KitDoll[] {
  if (_rootIsLegoKit(kd)) {
    return [ocopy(kd) as KitDoll];
  } else {
    return lcopy(kd.kitDolls ?? []);
  }
}
function _getAllLegos(kd: KitDoll, makeCopy = true): LegoDoll[] {
  let returnList = [] as LegoDoll[];
  if (_isLegoKit(kd) && kd.legoDolls) {
    returnList = makeCopy ? lcopy(kd.legoDolls ?? []) : kd.legoDolls ?? [];
  } else {
    returnList = [
      ...returnList,
      ...(kd.kitDolls ?? [])
        .map((k) => _getAllLegos(k, makeCopy) as LegoDoll[])
        .flat(),
    ];
  }
  return returnList;
}

// _getAllLegos({
//   kitInstanceId: "root",
//   kitDolls: [
//     { legoDolls: [{ legoInstanceId: 123 }], kitInstanceId: 987 },
//     {
//       legoDolls: [{ legoInstanceId: 456 }, { legoInstanceId: 789 }],
//       kitInstanceId: 123,
//     },
//   ],
// }); //=
// function testRef() {
//   const kd1 = {
//     legoDolls: [{ legoInstanceId: 456 }, { legoInstanceId: 789 }],
//     kitInstanceId: "root",
//   };
//   const legos = _getAllLegos(kd1 as KitDoll, false); //=
//   for (const ref of legos) {
//     ref.legoInstanceId = 999;
//   }
//   return kd1;
// }
// testRef(); //=

function _getAllLegosWithPaths(
  kd: KitDoll,
  pathToHere = ""
): [string, LegoDoll][] {
  let returnList = [] as [string, LegoDoll][];
  if (_isLegoKit(kd) && kd.legoDolls) {
    returnList = kd.legoDolls.map((ld) => [
      pathsJoin(pathToHere, _dollToPathPart(kd), _dollToPathPart(ld)),
      ld,
    ]);
  } else {
    returnList = [
      ...returnList,
      ...(kd.kitDolls ?? [])
        .map((k) =>
          _getAllLegosWithPaths(k, pathsJoin(pathToHere, _dollToPathPart(kd)))
        )
        .flat(),
    ];
  }
  return returnList;
}
// _getAllLegosWithPaths({
//   kitInstanceId: "root",
//   kitDolls: [
//     { legoDolls: [{ legoInstanceId: 123 }], kitInstanceId: 987 },
//     {
//       legoDolls: [{ legoInstanceId: 456 }, { legoInstanceId: 789 }],
//       kitInstanceId: 123,
//     },
//   ],
// }); //=
// _getAllLegosWithPaths({
//   legoDolls: [{ legoInstanceId: 456 }, { legoInstanceId: 789 }],
//   kitInstanceId: "root",
// }); //=

function _isEmpty(kd: KitDoll): boolean {
  return pyfalsey(kd) || _rootIsLegoKit(kd)
    ? (kd.legoDolls ?? []).length === 0
    : (kd.kitDolls ?? []).length === 0;
}
function _canBeAutoRun(kd: KitDoll, legoPath: string) {
  // doesn't have params, or all params have values
  const c = ocopy(kd) as KitDoll;
  const ref = _getLego(c, legoPath);
  return getAllEmptyRequiredElements(ref?.kitRunSchema ?? []).length === 0;
}

function _hasForEachButtons(kd: KitDoll, legoPath: string) {
  const c = ocopy(kd) as KitDoll;
  const ref = _getLego(c, legoPath);
  return pytruthy(ref?.forEachButtonsOnOutput);
}

function _isButtonSource(kd: KitDoll, legoPath: string) {
  const c = ocopy(kd) as KitDoll;
  const ref = _getLego(c, legoPath);
  return pytruthy(ref?.forEachButtonsIsRecevier);
}

function _buttonBlocksAreHidden(kd: KitDoll) {
  const c = ocopy(kd) as KitDoll;
  const legosAndPaths = _getAllLegosWithPaths(c);
  return legosAndPaths.some(([path, ld]) => {
    return ld.isHidden;
  });
}
/*

888       888         d8b 888                     
888   o   888         Y8P 888                     
888  d8b  888             888                     
888 d888b 888 888d888 888 888888 .d88b.  .d8888b  
888d88888b888 888P"   888 888   d8P  Y8b 88K      
88888P Y88888 888     888 888   88888888 "Y8888b. 
8888P   Y8888 888     888 Y88b. Y8b.          X88 
888P     Y888 888     888  "Y888 "Y8888   88888P' 
                                                  
                                                  
                                                  
*/

function _setLego(
  kd: KitDoll,
  legoPath: string,
  update: LegoDollUpdate
): KitDoll {
  const c = ocopy(kd) as KitDoll;
  const ref = _getLego(c, legoPath, false);
  if (!ref) {
    return c;
  }
  for (const key in update) {
    //@ts-ignore
    ref[key] = update[key];
  }
  console.log("C", c);
  return c;
}

/*


8888888b.                                   888                       .d8888b.  d8b 888               
888   Y88b                                  888                      d88P  Y88b Y8P 888               
888    888                                  888                      Y88b.          888               
888   d88P 8888b.  888d888 .d88b.  88888b.  888888 .d8888b            "Y888b.   888 88888b.  .d8888b  
8888888P"     "88b 888P"  d8P  Y8b 888 "88b 888    88K                   "Y88b. 888 888 "88b 88K      
888       .d888888 888    88888888 888  888 888    "Y8888b.                "888 888 888  888 "Y8888b. 
888       888  888 888    Y8b.     888  888 Y88b.       X88 d8b      Y88b  d88P 888 888 d88P      X88 
888       "Y888888 888     "Y8888  888  888  "Y888  88888P' 88P       "Y8888P"  888 88888P"   88888P' 
                                                            8P                                        
                                                            "                                         
                                                                                                      


*/
function _getParent(
  root: KitDoll,
  path: string,
  makeCopy = true
): KitDoll | null {
  const child = _get(root, path, makeCopy);
  if (child === null) {
    return null;
  }
  return _get(root, pathChopLast(path), makeCopy) as KitDoll;
}
// _getParent(
//   {
//     kitInstanceId: "root",
//     anchorLegoId: 123,
//     legoDolls: [{ legoInstanceId: 5 }],
//   },
//   "root.li_5"
// ); //=
function _getGrandparent(
  root: KitDoll,
  path: string,
  makeCopy = true
): KitDoll | null {
  return _get(root, pathChopLast(pathChopLast(path)), makeCopy) as KitDoll;
}
function _hasSibling(kd: KitDoll, path: string): boolean {
  const parent = _getParent(kd, path);
  if (_isLeaf(pathLast(path))) {
    return (parent?.legoDolls ?? []).length > 1;
  } else {
    return (parent?.kitDolls ?? []).length > 1;
  }
}
// _hasSibling(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           { legoInstanceId: 5 },
//           { legoInstanceId: 2 },
//           { legoInstanceId: 10 },
//         ],
//       },
//     ],
//   },
//   "root.ki_456.li_5"
// ); //=
function _getSiblings(kd: KitDoll, path: string): KitDoll[] | LegoDoll[] {
  const parent = _getParent(kd, path);
  if (_isLeaf(pathLast(path))) {
    return (parent?.legoDolls ?? []).filter(
      (l) => !_idEquals(pathLast(path), l.legoInstanceId)
    );
  } else {
    return (parent?.kitDolls ?? []).filter(
      (l) => !_idEquals(pathLast(path), l.kitInstanceId)
    );
  }
}
// _getSiblings(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           { legoInstanceId: 5 },
//           { legoInstanceId: 2 },
//           { legoInstanceId: 10 },
//         ],
//       },
//     ],
//   },
//   "root.ki_456.li_5"
// ); //=

/*



 .d8888b.                                    888      
d88P  Y88b                                   888      
Y88b.                                        888      
 "Y888b.    .d88b.   8888b.  888d888 .d8888b 88888b.  
    "Y88b. d8P  Y8b     "88b 888P"  d88P"    888 "88b 
      "888 88888888 .d888888 888    888      888  888 
Y88b  d88P Y8b.     888  888 888    Y88b.    888  888 
 "Y8888P"   "Y8888  "Y888888 888     "Y8888P 888  888 
                                                      
                                                      
                                                      

*/
function _findAll(
  kd: KitDoll,
  cond: (node: LegoDoll | KitDoll) => boolean,
  makeCopy = true
): (LegoDoll | KitDoll)[] {
  const results: (LegoDoll | KitDoll)[] = [];
  if (cond(kd)) {
    results.push((makeCopy ? ocopy(kd) : kd) as KitDoll);
  }
  for (const lego of kd.legoDolls ?? []) {
    if (cond(lego)) {
      results.push((makeCopy ? ocopy(lego) : lego) as LegoDoll);
    }
  }
  for (const k of kd.kitDolls ?? []) {
    results.push(..._findAll(k, cond, makeCopy));
  }
  return results;
}
function _findAllLegos(
  kd: KitDoll,
  cond: (ld: LegoDoll) => boolean,
  makeCopy = true
): LegoDoll[] {
  return _findAll(
    kd,
    cond as (e: LegoDoll | KitDoll) => boolean,
    makeCopy
  ) as LegoDoll[];
}

// _findAll(
//   { kitInstanceId: "root" },
//   (e) => "kitInstanceId" in e && e.kitInstanceId === "nada"
// ); //=
// _findAll(
//   { kitInstanceId: "root" },
//   (e) => "kitInstanceId" in e && e.kitInstanceId === "root"
// ); //=
// _findAll(
//   {
//     kitInstanceId: "root",
//     legoDolls: [{ legoId: 5 }, { legoId: 5 }, { legoId: 10 }],
//   },
//   (e) => "legoId" in e && e.legoId === 5
// ); //=
// _findAll(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 123,
//         legoDolls: [{ legoId: 5 }, { legoId: 5 }, { legoId: 10 }],
//       },
//       {
//         kitInstanceId: 123,
//         legoDolls: [{ legoId: 5 }, { legoId: 5 }, { legoId: 10 }],
//       },
//     ],
//   },
//   (e) => "legoId" in e && e.legoId === 5
// );
function _findAllWithPaths(
  kd: KitDoll,
  cond: (node: LegoDoll | KitDoll) => boolean,
  makeCopy = true,
  pathToHere = ""
): [string, LegoDoll | KitDoll][] {
  const results: [string, LegoDoll | KitDoll][] = [];
  if (cond(kd)) {
    results.push([
      pathJoin(pathToHere, _dollToPathPart(kd)),
      (makeCopy ? ocopy(kd) : kd) as KitDoll,
    ]);
  }
  for (const lego of kd.legoDolls ?? []) {
    if (cond(lego)) {
      results.push([
        pathsJoin(pathToHere, _dollToPathPart(kd), _dollToPathPart(lego)),
        (makeCopy ? ocopy(lego) : lego) as LegoDoll,
      ]);
    }
  }
  for (const k of kd.kitDolls ?? []) {
    results.push(
      ..._findAllWithPaths(
        k,
        cond,
        makeCopy,
        pathJoin(pathToHere, _dollToPathPart(kd))
      )
    );
  }
  return results;
}
function _findAllLegosWithPaths(
  kd: KitDoll,
  cond: (ld: LegoDoll) => boolean,
  makeCopy = true
): [string, LegoDoll][] {
  return _findAllWithPaths(
    kd,
    (e: LegoDoll | KitDoll) => _isDollLeaf(e) && cond(e as LegoDoll),
    makeCopy
  ) as [string, LegoDoll][];
}

function _indexInParent(kd: KitDoll, path: string): number {
  if (
    pathFirst(path) == "root" &&
    pathLength(path) == 1 &&
    _idEquals(path, kd.kitInstanceId)
  ) {
    return 0;
  } else if (
    _isBranch(pathFirst(path)) &&
    _isLeaf(pathPeekSecond(path)) &&
    _idEquals(pathFirst(path), kd.kitInstanceId)
  ) {
    return lfindIndex(kd.legoDolls || [], (l) =>
      _idEquals(pathPeekSecond(path), l.legoInstanceId)
    );
  } else if (
    _isBranch(pathFirst(path)) &&
    _idEquals(pathFirst(path), kd.kitInstanceId)
  ) {
    let found = -1;
    for (const k of kd.kitDolls ?? []) {
      found = _indexInParent(k, pathRest(path));
      if (found >= 0) {
        return found;
      }
    }
  }

  return -1;
}

// _indexInParent({kitInstanceId: "root"}}, "nada") //=
// _indexInParent({kitInstanceId: "root"}}, "root") //=
// _indexInParent({kitInstanceId: "root", legoDolls: [{legoInstanceId: 5}, {legoInstanceId: 2}, {legoInstanceId:123}]}, "root.li_123") //=
// _indexInParent({kitInstanceId: "root", kitDolls: [{kitInstanceId: 456, legoDolls: [{legoInstanceId: 5}, {legoInstanceId: 2}, {legoInstanceId:123}]}]}, "root.ki_456.li_123") //=

type ElementResult = {
  legoPath: string;
  legoName: string;
  elementPath: string;
};

function _findAllElementsWithPaths(
  kd: KitDoll,
  cond: (e: KitRunSchemaElement) => boolean,
  makeCopy = true,
  pathToHere = ""
): ElementResult[] {
  const results: ElementResult[] = [];
  for (const lego of kd.legoDolls ?? []) {
    const matches = lego.kitRunSchema
      .map((e) => findAllItemsInElement(e, cond))
      .flat()
      .map(([path, el]) => ({
        legoPath: pathsJoin(
          pathToHere,
          _dollToPathPart(kd),
          _dollToPathPart(lego)
        ),
        legoName: lego.legoName,
        elementPath: path,
      }));
    results.push(...matches);
  }
  for (const k of kd.kitDolls ?? []) {
    results.push(
      ..._findAllElementsWithPaths(
        k,
        cond,
        makeCopy,
        pathJoin(pathToHere, _dollToPathPart(kd))
      )
    );
  }
  return results;
}
function _findAllReceivers(
  kd: KitDoll,
  senderPath: string,
  addtlCond: (e: KitRunSchemaElement) => boolean = () => true
): {
  legoPath: string;
  legoName: string;
  elementPath: string;
}[] {
  let legoKitSiblingResults = [] as {
    legoPath: string;
    legoName: string;
    elementPath: string;
  }[];
  if (!_rootIsLegoKit(kd)) {
    // if we're in a larger kit, there could be receivers within
    // lego kits whose paths are relative to the lego kit, NOT the full kit
    const parent = _getParent(kd, senderPath);
    if (parent) {
      const resultsInSubtree = _findAllElementsWithPaths(
        parent,
        (e: KitRunSchemaElement) =>
          e.paramSender?.path === pathJoin("root", pathLast(senderPath)) &&
          addtlCond(e)
      );
      legoKitSiblingResults = resultsInSubtree.map((r) => ({
        legoPath: pathJoin(pathChopLast(senderPath), pathLast(r.legoPath)),
        legoName: r.legoName,
        elementPath: r.elementPath,
      }));
    }
  }
  const results = _findAllElementsWithPaths(
    kd,
    (e: KitRunSchemaElement) =>
      e.paramSender?.path === senderPath && addtlCond(e)
  );
  return [...results, ...legoKitSiblingResults];
}
/*



       d8888                   888                            888                                         
      d88888                   888                            888                                         
     d88P888                   888                            888                                         
    d88P 888 88888b.   .d8888b 88888b.   .d88b.  888d888      888      .d88b.   .d88b.   .d88b.  .d8888b  
   d88P  888 888 "88b d88P"    888 "88b d88""88b 888P"        888     d8P  Y8b d88P"88b d88""88b 88K      
  d88P   888 888  888 888      888  888 888  888 888          888     88888888 888  888 888  888 "Y8888b. 
 d8888888888 888  888 Y88b.    888  888 Y88..88P 888          888     Y8b.     Y88b 888 Y88..88P      X88 
d88P     888 888  888  "Y8888P 888  888  "Y88P"  888          88888888 "Y8888   "Y88888  "Y88P"   88888P' 
                                                                                    888                   
                                                                               Y8b d88P                   
                                                                                "Y88P"                    

                                                      

*/
function _findFirstAnchorLego(kd: KitDoll): LegoDoll | null {
  if (kd.anchorLegoId) {
    return lfind(kd.legoDolls || [], (l) => l.legoId == kd.anchorLegoId, null);
  } else {
    for (const k of kd.kitDolls ?? []) {
      const found = _findFirstAnchorLego(k);
      if (found) {
        return found;
      }
    }
  }
  return null;
}
function _getAnchorLego(
  kd: KitDoll,
  anchorPathOrSiblingPath: string
): LegoDoll | null {
  // works on the anchor lego itself or any siblings
  // not implemented yet - path to parent
  const parent = _getParent(kd, anchorPathOrSiblingPath);
  if (parent === null) return null;
  return lfind(
    parent.legoDolls ?? [],
    (l) => l.legoId == parent.anchorLegoId,
    null,
    true
  );
}

// _getAnchorLego(
//   {
//     kitInstanceId: "root",
//     anchorLegoId: 888,
//     legoDolls: [
//       { legoId: 888, legoInstanceId: 2 },
//       { legoId: 2, legoInstanceId: 123 },
//     ],
//   },
//   "root.li_123"
// ); //=
// _getAnchorLego(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         anchorLegoId: 888,
//         legoDolls: [
//           { legoId: 888, legoInstanceId: 2 },
//           { legoId: 2, legoInstanceId: 123 },
//         ],
//         kitInstanceId: 456,
//       },
//     ],
//   },
//   "root.ki_456.li_123"
// ); //=
function _isAnchorLego(kd: KitDoll, path: string): boolean {
  if (!_isLeaf(pathLast(path)) || !_isBranch(pathLast(pathChopLast(path)))) {
    return false;
  }
  const lego = _get(kd, path) as LegoDoll;
  if (lego === null) {
    return false;
  }
  const parent = _getParent(kd, path);
  if (parent === null) {
    return false;
  }

  return parent.anchorLegoId === lego.legoId;
}
/*

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

*/

/*


888     888 8888888b.  888           8888888b.                                                 
888     888 888   Y88b 888           888   Y88b                                                
888     888 888    888 888           888    888                                                
888     888 888   d88P 888           888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b  
888     888 8888888P"  888           8888888P"     "88b 888P"      "88b 888 "888 "88b 88K      
888     888 888 T88b   888           888       .d888888 888    .d888888 888  888  888 "Y8888b. 
Y88b. .d88P 888  T88b  888           888       888  888 888    888  888 888  888  888      X88 
 "Y88888P"  888   T88b 88888888      888       "Y888888 888    "Y888888 888  888  888  88888P' 
                                                                                               
                                                                                               
                                                                                               
*/
const sortKitBuilderQueryParams = (
  [k1, v1]: [string, unknown],
  [k2, v2]: [string, unknown]
) => {
  if (k1 === "id") {
    return -1;
  } else if (k2 === "id") {
    return 1;
  } else if (k1 === "runId") {
    return -1;
  } else if (k2 === "runId") {
    return 1;
  } else if (k1 === "params") {
    return 1;
  } else if (k2 === "params") {
    return -1;
  } else {
    return 0;
  }
};
function _toExcelFormula(
  kd: KitDoll,
  origin: string,
  path: string,
  queryObj: any,
  hyperlinkText: string
) {
  // Not making a copy here since this method is read only and needs to be fast
  const allLegos: [string, LegoDoll][] = _getAllLegosWithPaths(kd);
  let paramQs = allLegos
    .map(([legoPath, ld]) =>
      schemaToExcelPreppedString(legoPath, ld.kitRunSchema)
    )
    .filter((qs) => qs.length !== 0)
    .join(",");
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%,/g, '"&A2&",');
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%$/, '"&A2&"'); // params at end
  let queryString = oitems(
    omerge(queryObj, paramQs.length > 0 ? { params: paramQs } : {})
  )
    // sort array where 'id' is first, 'runId' is second and 'params' are last
    .sort(sortKitBuilderQueryParams)
    .map(([k, v]) => `${k}=${v}`)
    .join("&");
  queryString = queryString.length > 0 ? `?${queryString}` : "";
  return `=HYPERLINK("${origin}${path}${queryString}", "${hyperlinkText}")`;
}

function _toQueryString(kd: KitDoll) {
  // Not making a copy here since this method is read only and needs to be fast
  const allLegos: [string, LegoDoll][] = _getAllLegosWithPaths(kd);
  return allLegos
    .map(([legoPath, ld]) => schemaToQueryString(legoPath, ld.kitRunSchema))
    .filter((qs) => qs.length !== 0)
    .join(",");
}
function _extractLegoPath(fullPath: string) {
  const leafIdx = lfindIndex(pathSplit(fullPath), (p) => _isLeaf(p));
  return pathsJoin(...(pathSplit(fullPath).slice(0, leafIdx + 1) as string[]));
}
function _extractParamPath(fullPath: string) {
  const leafIdx = lfindIndex(pathSplit(fullPath), (p) => _isLeaf(p));
  return pathsJoin(...(pathSplit(fullPath).slice(leafIdx + 1) as string[]));
}

// _extractLegoPath("root.ki_123.li_456.this.is.nested"); //=
// _extractParamPath("root.ki_123.li_456.this.is.nested"); //=

function _bindUrlParams(
  kd: KitDoll,
  urlParams: Record<string, string> | null,
  depth = 0
) {
  if (urlParams === null) {
    return kd;
  }
  const lookupByInstance = ovaluemap(
    lgroupBy(
      oitems(urlParams).map(([k, v]: [string, any]) => [
        _extractLegoPath(k),
        _extractParamPath(k),
        v,
      ]),
      ([i, k, v]) => i
    ),
    (v: unknown) =>
      lot2o((v as [string, string, string][]).map(([i, k, v]) => [k, v]))
  );
  let c;
  if (depth == 0) {
    c = ocopy(kd) as KitDoll;
  } else {
    c = kd;
  }
  const allLegos: [string, LegoDoll][] = _getAllLegosWithPaths(c);
  for (const [path, ref] of allLegos) {
    ref.kitRunSchema = bindFlatParamsToSchema(
      ref.kitRunSchema,
      oget(lookupByInstance, path)
    );
  }
  return c;
}

// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3A%22United%20States%22,root.li_5000.post_date%3A%3A%3A%22Past%20Month%22,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A%2211-50%20employees%22,root.li_5000.company_size%5B1%5D%3A%3A%3A%2251-200%20employees%22,root.li_5000.company_size%5B2%5D%3A%3A%3A%22501-1000%20employees%22,root.li_5000.company_size%5B3%5D%3A%3A%3A%225001-10000%20employees%22,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3A%22her,her,her%22,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3AUnited%20States,root.li_5000.post_date%3A%3A%3APast%20Month,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A11-50%20employees,root.li_5000.company_size%5B1%5D%3A%3A%3A51-200%20employees,root.li_5000.company_size%5B2%5D%3A%3A%3A501-1000%20employees,root.li_5000.company_size%5B3%5D%3A%3A%3A5001-10000%20employees,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3Aher,null%3A%3A%3Anull,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-demos-1/builder?id=12634&runGroupId=4285&params=root.li_12382.job_title%3A%3A%3Ahello,root.li_12382.exclude_staffing_agencies%3A%3A%3Afalse,root.li_12382.use_flank_hm_identifier%3A%3A%3Afalse";
// const qps = pathToQueryParams(path); //=
// import pe from "./paramExamples";
// _bindUrlParams(pe.kitDoll2, qps.params); //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     legoDolls: [
//       { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//       { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//     ],
//   },
//   { "root.li_5.hi": "1" }
// ).legoDolls[0]; //=
// https://www.flank.cloud/flank-demos-1/builder?id=9352&runGroupId=2695&params=root.ki_281.li_9203.What%20is%20it%3F%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_283.li_9205.Emotions%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_285.li_9207.Size%20and%20structure%3A%3A%3A%22big%20and%20structured%22,root.ki_287.li_9209.Looks%20and%20vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_289.li_9211.Camera%20proximity%3A%3A%3A%22long%20shot%22,root.ki_291.li_9213.Camera%20position%3A%3A%3A%22overhead%20view%22,root.ki_293.li_9215.Camera%20lens%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_295.li_9217.Outdoor%20lighting%3A%3A%3Aovercast,root.ki_297.li_9219.Indoor%20lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_301.li_9223.Film%20style%3A%3A%3Apolaroid,root.ki_303.li_9225.Photo%20genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.what_is_it%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_280.li_9025.emotion%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_280.li_9025.sizey_structurey_words%3A%3A%3A%22big%20and%20structured%22,root.ki_280.li_9025.looks_and_vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_280.li_9025.camera_proximity%3A%3A%3A%22long%20shot%22,root.ki_280.li_9025.camera_position%3A%3A%3A%22overhead%20view%22,root.ki_280.li_9025.camera_lenses%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_280.li_9025.outdoor_lighting%3A%3A%3Aovercast,root.ki_280.li_9025.indoor_lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_280.li_9025.film_styles%3A%3A%3Apolaroid,root.ki_280.li_9025.photo_genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.portrait_photographer%3A%3A%3A,root.ki_280.li_9025.illustration_style%3A%3A%3A,root.ki_280.li_9025.art_history_style%3A%3A%3A,root.ki_280.li_9025.statue_style%3A%3A%3A,root.ki_280.li_9025.paper_and_textiles%3A%3A%3A,root.ki_280.li_9025.ceramics_and_glass%3A%3A%3A
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//           { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi": "1" }
// ).kitDolls[0].legoDolls[0]; //=
// _bindUrlParams2(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 value: "",
//                 jsonType: "object",
//                 objectPropertySchemas: [{ key: "there", value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi.there": "1" }
// ).kitDolls[0].legoDolls[0].kitRunSchema[0].objectPropertySchemas; //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 jsonType: "array",
//                 listElements: [{ value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi[0]": "1" }
// ).kitDolls[0].legoDolls[0].kitRunSchema[0].listElements[0]; //=

function _mapLegoKitQueryParamPathsToKingKitPaths(
  params: Record<string, string>,
  kd: KitDoll
): Record<string, string> {
  const legoInstanceIds = lunique(okeys(params).map((k) => pathPeekSecond(k)));
  // console.log(legoInstanceIds);
  const replacements = lot2o(
    _findAllLegosWithPaths(kd, (node: LegoDoll) =>
      legoInstanceIds.includes(_dollToPathPart(node))
    ).map(([path, ld]) => {
      return [_dollToPathPart(ld), pathRest(path)];
    })
  ) as Record<string, string>;
  return okeymap(params, (k) => sReplaceFromObj(k, replacements)) as Record<
    string,
    string
  >;
}

// _mapLegoKitQueryParamPathsToKingKitPaths(
//   {
//     "root.li_4873.@name": "j",
//     "root.li_4873.@age": "12",
//     "root.li_4874.@age": "12",
//   },
//   {
//     kitInstanceId: "root",
//     kitDolls: [
//       {
//         kitInstanceId: 8282,
//         legoDolls: [{ legoInstanceId: 4873 }, { legoInstanceId: 4874 }],
//       },
//     ],
//   } as KitDoll
// ); //=

type TuplePair = [any, any];

function _flattenOnceNestedTuples(
  list: Array<TuplePair | TuplePair[]>
): TuplePair[] {
  const flattened: TuplePair[] = [];

  for (const item of list) {
    if (isArray(item[0])) {
      flattened.push(...(item as TuplePair[]));
    } else {
      flattened.push(item as TuplePair);
    }
  }

  return flattened;
}

// const data = [
//   ["k1", "v1"],
//   ["k2", "v2"],
//   [
//     ["k3", "v3"],
//     ["k4", "v4"],
//   ],
// ];
// flattenOnceNestedTuples(data); //=

function _addressAmbiguousParams(
  kd: KitDoll,
  params: Record<string, string> | null
): Record<string, string> | null {
  if (params === null) return params;
  const list = oitems(params).map(([k, v]) => {
    if (k.includes("root.li_") || k.includes("root.ki_")) {
      return [k, v];
    } else {
      const matchingElements = _findAllElementsWithPaths(
        kd,
        (e) => e.key === k
      );
      if (matchingElements.length > 0) {
        return matchingElements.map((er: ElementResult) => [
          pathJoin(er.legoPath, er.elementPath),
          v,
        ]);
      } else {
        return [k, v];
      }
    }
  }) as Array<TuplePair | TuplePair[]>;

  return lot2o(_flattenOnceNestedTuples(list)) as Record<string, string>;
}
// const p1 =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=root.li_2976.%40userId%3A%3A%3A2";
// const p =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=%40userIdd%3A%3A%3A2";
// pathToQueryParams(p); //=
// const sch = [
//   {
//     key: "@userId",
//     typeSystem: "mssql",
//     typeId: "int",
//     jsonType: "number",
//     component: "b-input",
//     inputType: "number",
//     objectPropertySchemas: null,
//     listElementSchema: null,
//     defaultValue: null,
//     defaultAmbiguousInput: null,
//     useDefaultValue: false,
//     lockDefaultValue: false,
//     hidden: false,
//     note: "",
//     manuallyAdded: false,
//     uuid: "2908e306-5d01-40c5-9e54-48faeba9df29",
//     listElements: null,
//     value: 2,
//     isValid: true,
//   },
// ];
// const kd = {
//   kitId: 2994,
//   kitDolls: null,
//   legoDolls: [
//     {
//       legoId: 886,
//       order: 0,
//       legoInstanceId: 4979,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           paramSender: {
//             path: "root.li_4979",
//             uiType: "dropdown",
//             referenceType: "column",
//             references: { valueColField: "user_id", displayColField: "name" },
//           },
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],

//       legoName: "get_users",
//       legoDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_users",
//       cloudName: "get_users",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: true,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       forEachButtonsOnOutput: null,
//       forEachButtonsIsRecevier: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//     {
//       legoId: 897,
//       order: 1,
//       legoInstanceId: 2976,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           paramSender: {
//             path: "root.li_4979",
//             uiType: "dropdown",
//             referenceType: "column",
//             references: { valueColField: "user_id", displayColField: "name" },
//           },
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],
//       legoName: "getUserAge",
//       legoDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::getUserAge",
//       cloudName: "getUserAge",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: false,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       forEachButtonsOnOutput: null,
//       forEachButtonsIsRecevier: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//   ],
//   kitInstanceId: "root",
//   anchorLegoId: 897,
//   order: 0,
//   name: "getUserAge",
//   visibility: "org",
//   directoryId: null,
// };

// _addressAmbiguousParams(kd, pathToQueryParams(p).params); //=
/*


8888888b.            .d888                  888 888         888     888         888                            
888  "Y88b          d88P"                   888 888         888     888         888                            
888    888          888                     888 888         888     888         888                            
888    888  .d88b.  888888 8888b.  888  888 888 888888      Y88b   d88P 8888b.  888 888  888  .d88b.  .d8888b  
888    888 d8P  Y8b 888       "88b 888  888 888 888          Y88b d88P     "88b 888 888  888 d8P  Y8b 88K      
888    888 88888888 888   .d888888 888  888 888 888           Y88o88P  .d888888 888 888  888 88888888 "Y8888b. 
888  .d88P Y8b.     888   888  888 Y88b 888 888 Y88b.          Y888P   888  888 888 Y88b 888 Y8b.          X88 
8888888P"   "Y8888  888   "Y888888  "Y88888 888  "Y888          Y8P    "Y888888 888  "Y88888  "Y8888   88888P' 
                                                                                                               
                                                                                                               
                                                                                                               
*/
function _setDefaultValues(kd: KitDoll, depth = 0) {
  let c;
  if (depth == 0) {
    c = ocopy(kd) as KitDoll;
  } else {
    c = kd;
  }
  if (_isLegoKit(c) && c.legoDolls) {
    c.legoDolls = c.legoDolls.map((l) =>
      oset(l, "kitRunSchema", setSchemaValuesToDefaults(l.kitRunSchema))
    );
    if (c.legoDolls.length > 1) {
      // zz("l > 1");
    }
  } else {
    c.kitDolls = (c.kitDolls ?? []).map((k) => _setDefaultValues(k, depth + 1));
  }
  return c;
}

function _collapseSenders(kd: KitDoll) {
  let c = ocopy(kd) as KitDoll;
  const legosAndPaths = _getAllLegosWithPaths(c);
  console.log("legosAndPaths", legosAndPaths);
  for (const [path, ref] of legosAndPaths ?? []) {
    const ref = _getLego(c, path);
    if (
      (!_isAnchorLego(c, path) &&
        _rootIsLegoKit(c) &&
        _canBeAutoRun(c, path)) ||
      (_findAllReceivers(
        c,
        path,
        (e: KitRunSchemaElement) =>
          e.paramSender?.referenceType !== "schemaElement"
      ).length > 0 &&
        _canBeAutoRun(c, path) &&
        !_hasForEachButtons(c, path))
    ) {
      console.log("ref should be collapsed", ref);
      c = _setLego(c, path, { collapsedView: true });
    }
  }
  return c;
}

function _hideButtonSources(kd: KitDoll, isHidden: boolean) {
  let c = ocopy(kd) as KitDoll;
  const legosAndPaths = _getAllLegosWithPaths(c);
  console.log("legosAndPaths", legosAndPaths);
  for (const [path, ref] of legosAndPaths ?? []) {
    const ref = _getLego(c, path);
    if (_isButtonSource(c, path)) {
      console.log("ref should be hidden", ref);
      c = _setLego(c, path, { isHidden: isHidden });
    }
  }
  return c;
}

/*

888     888 888    d8b 888          
888     888 888    Y8P 888          
888     888 888        888          
888     888 888888 888 888 .d8888b  
888     888 888    888 888 88K      
888     888 888    888 888 "Y8888b. 
Y88b. .d88P Y88b.  888 888      X88 
 "Y88888P"   "Y888 888 888  88888P'
                                    
                                    
                                    
*/
function _elementSet(
  kd: KitDoll,
  legoPath: string,
  elementPath: string,
  valueFunc: (e: KitRunSchemaElement) => any,
  attribute: string
): KitDoll {
  const c = ocopy(kd) as KitDoll;
  const ref = _getLego(c, legoPath, false); // make copy
  if (!ref) return c;
  ref.kitRunSchema = elementSetInSchema(
    ref.kitRunSchema,
    elementPath,
    valueFunc,
    attribute
  );
  return c;
}

function _elementGet(kd: KitDoll, legoPath: string, elementPath: string) {
  const lego = _getLego(kd, legoPath);
  return elementGetInSchema(lego?.kitRunSchema ?? [], elementPath);
}
/*



8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             

                                                                       
                                                                       
                                                                       

*/

/*


 .d8888b.                             
d88P  Y88b                            
Y88b.                                 
 "Y888b.   888  888 88888b.   .d8888b 
    "Y88b. 888  888 888 "88b d88P"    
      "888 888  888 888  888 888      
Y88b  d88P Y88b 888 888  888 Y88b.    
 "Y8888P"   "Y88888 888  888  "Y8888P 
                888                   
           Y8b d88P                   
            "Y88P"                    

            */

function _planToSync(kd: KitDoll, path: string): KitDollPlan {
  const legoDoll = _get(kd, path) as LegoDoll;
  if (legoDoll === null) {
    return new KitDollPlan({ kitDoll: kd });
  }
  const kili = !_rootIsLegoKit(kd);
  return new KitDollPlan({
    kitDollRequest: {
      method: HttpMethod.POST,
      path: "syncs",
      body: { legoId: legoDoll.legoId, credsId: legoDoll.syncCredsId },
      options: { orgPath: true },
      callback: (syncResp: SyncWrapper) => {
        return {
          method: HttpMethod.GET,
          path: `kits/${kd.kitId}/legos/${legoDoll.legoId}`,
          options: {
            orgPath: true,
            query: { filter: ["is_deleted:False"] },
          },
          callback: (legoResp: ELegoGET) =>
            _updateLegoAfterSync(kd, legoResp, kili),
        };
      },
    },
  });
}
function _updateLegoAfterSync(kd: KitDoll, lego: ELegoGET, kili: boolean) {
  const c = ocopy(kd) as KitDoll;
  const legosAndPaths = _findAllLegosWithPaths(
    c,
    (e) => e.legoId === lego.legoId,
    false // don't make copies, get refs
  );
  for (const [path, ref] of legosAndPaths ?? []) {
    ref.kitRunSchema = injectLegoSchemaIntoKitRunSchema(
      ref.kitRunSchema,
      strToSchema(lego.paramSchema)
    );
    ref.legoName = lego.name;
    ref.legoDescription = lego.description;
  }

  const parallelRequests = [] as ApiRequest[];
  for (const [path, ref] of legosAndPaths ?? []) {
    const parent = _getParent(kd, path);
    if (parent) {
      parallelRequests.push(_apiRequestForSchemaUpdate(ref, parent, kili, ""));
    }
  }

  return { kitDoll: c, parallelRequests: parallelRequests };
}
// _updateLegoAfterSync(
//   {
//     kitInstanceId: "root",
//     legoDolls: [
//       {
//         legoId: 561,
//         kitRunSchema: [{ key: "@a", typeId: "int", value: "123" }],
//       },
//     ],
//   },
//   oKeysToCamel({
//     org_id: "sandbox-119",
//     param_schema:
//       '[{"key": "@a", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@b", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@c", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@s", "type_system": "mssql", "type_id": "varchar", "json_type": "string", "component": "b-input", "input_type": "text", "constraints": {"multiple_of": null, "maximum": null, "exclusive_maximum": null, "minimum": null, "exclusive_minimum": null, "max_length": 25, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": null}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@d", "type_system": "mssql", "type_id": "float", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": null, "exclusive_maximum": null, "minimum": null, "exclusive_minimum": null, "max_length": 8, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "any"}, "object_property_schemas": null, "list_element_schema": null}]',
//     lego_id: 561,
//   })
// ).legoDolls[0].kitRunSchema; //=

/*

888     888               888          888            
888     888               888          888            
888     888               888          888            
888     888 88888b.   .d88888  8888b.  888888 .d88b.  
888     888 888 "88b d88" 888     "88b 888   d8P  Y8b 
888     888 888  888 888  888 .d888888 888   88888888 
Y88b. .d88P 888 d88P Y88b 888 888  888 Y88b. Y8b.     
 "Y88888P"  88888P"   "Y88888 "Y888888  "Y888 "Y8888  
            888                                       
            888                                       
            888                                       

*/
function _replace(
  kd: KitDoll,
  path: string,
  newNode: LegoDoll | KitDoll
): KitDoll {
  const c = ocopy(kd) as KitDoll; // only make copy at root

  if (path === "root") {
    return newNode as KitDoll;
  } else {
    const parentRef = _getParent(c, path, false);
    if (parentRef === null) return c;
    if (_isLeaf(pathLast(path)) && parentRef.legoDolls) {
      const idx = lfindIndex(parentRef.legoDolls ?? [], (ld) =>
        _idEquals(pathLast(path), ld.legoInstanceId)
      );
      if (idx == -1) return c;
      parentRef.legoDolls[idx] = newNode as LegoDoll;
    } else if (parentRef.kitDolls) {
      const idx = lfindIndex(parentRef.kitDolls ?? [], (ld) =>
        _idEquals(pathLast(path), ld.kitInstanceId)
      );
      if (idx == -1) return c;
      parentRef.kitDolls[idx] = newNode as KitDoll;
    }
  }
  return c;
}

// _replace({ kitInstanceId: "root" }, "root", {
//   kitInstanceId: "root",
//   kitId: 1324,
// }); //=
// _replace({ kitInstanceId: "root" }, "nada", {
//   kitInstanceId: "root",
//   kitId: 1324,
// }); //=
// _replace(
//   { kitInstanceId: "root", legoDolls: [{ legoInstanceId: 123 }] },
//   "root.li_123",
//   { legoInstanceId: 123, legoId: 888 }
// ); //=
// _replace(
//   {
//     kitInstanceId: "root",
//     kitDolls: [{ kitInstanceId: 777, legoDolls: [{ legoInstanceId: 123 }] }],
//   },
//   "root.ki_777.li_123",
//   { legoInstanceId: 123, legoId: 888 }
// ).kitDolls[0].legoDolls; //=

// // DOES NOt ADD NEW NODES
// _replace(
//   {
//     kitInstanceId: "root",
//     kitDolls: [{ kitInstanceId: 777, legoDolls: [{ legoInstanceId: 62 }] }],
//   },
//   "root.ki_777.li_123",
//   { legoInstanceId: 123, legoId: 888 }
// ).kitDolls[0].legoDolls; //=
// _replace(
//   { kitInstanceId: "root", kitDolls: [{ kitInstanceId: 456 }] },
//   "root.ki_456",
//   { kitInstanceId: 456, legoId: 888 }
// ); //=

function _planToUpdateLego(
  kd: KitDoll,
  old: LegoDoll,
  updated: LegoDoll,
  path: string
): KitDollPlan {
  const [l, r] = odiffOldNew(old, updated);
  const diff = r;
  if (pyfalsey(diff)) {
    return new KitDollPlan({ kitDoll: kd });
  }

  const parentKit = _getParent(kd, path) as KitDoll;

  const parallelRequests = [] as ApiRequest[];
  const legoFields = [
    "legoName",
    "legoDescription",
    "warningTag",
    "runButtonText",
    "runningMessage",
    "runOnStartup",
    "runOnStartupValues",
  ];
  const kitFields = ["directoryId"];
  const legoInstanceFields = ["kitRunSchema"];
  const legoDiff = okeyfilter(diff, (k) => legoFields.includes(k));
  const kitDiff = okeyfilter(diff, (k) => kitFields.includes(k));
  const legoInstanceDiff = okeyfilter(diff, (k) =>
    legoInstanceFields.includes(k)
  );
  if (pytruthy(legoDiff)) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `legos/${updated.legoId}`,
      body: omerge(
        "legoName" in diff ? { overrideName: diff.legoName } : {},
        "legoDescription" in diff ? { description: diff.legoDescription } : {},
        "warningTag" in diff ? { warningTag: diff.warningTag } : {},
        "runButtonText" in diff ? { runButtonText: diff.runButtonText } : {},
        "runningMessage" in diff ? { runningMessage: diff.runningMessage } : {},
        "runOnStartup" in diff ? { runOnStartup: diff.runOnStartup } : {},
        "runOnStartupValues" in diff
          ? {
              runOnStartupValues: runramsToStr(diff.runOnStartupValues),
            }
          : {}
      ),
      options: { orgPath: true },
    });
    if ("legoName" in diff && parentKit) {
      parallelRequests.push({
        method: HttpMethod.PATCH,
        path: `skinny-kits/${parentKit.kitId}`,
        body: { name: diff.legoName },
        options: { orgPath: true },
      });
    }
  }
  if (pytruthy(kitDiff)) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `skinny-kits/${kd.kitId}`,
      body: { directoryId: diff.directoryId },
      options: { orgPath: true },
    });
  }
  if (pytruthy(legoInstanceDiff)) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${parentKit ? parentKit.kitId : kd.kitId}/lego_instances/${
        updated.legoInstanceId
      }`,
      body: {
        instanceParamSchema: schemaToStr(
          trimDownSchema(updated.kitRunSchema, {
            from: "kitrun",
            to: "instance",
          })
        ),
      },
      options: { orgPath: true },
    });
  }

  return new KitDollPlan({
    kitDoll: _replace(kd, path, updated),
    parallelRequests,
  });
}

/*

8888888b.                                                   
888   Y88b                                                  
888    888                                                  
888   d88P .d88b.  88888b.d88b.   .d88b.  888  888  .d88b.  
8888888P" d8P  Y8b 888 "888 "88b d88""88b 888  888 d8P  Y8b 
888 T88b  88888888 888  888  888 888  888 Y88  88P 88888888 
888  T88b Y8b.     888  888  888 Y88..88P  Y8bd8P  Y8b.     
888   T88b "Y8888  888  888  888  "Y88P"    Y88P    "Y8888  
                                                            
                                                            
                                                            
*/

function _planToRemove(kd: KitDoll, path: string): KitDollPlan {
  const c = ocopy(kd) as KitDoll; // only make copy at root

  if (path === "root") {
    throw Error("Can't remove root!");
  } else {
    if (_isLegoKit(c) && _isLeaf(pathLast(path))) {
      const parentRef = _getParent(c, path, false);
      if (parentRef === null || !parentRef.legoDolls) {
        return new KitDollPlan({ kitDoll: c });
      }
      const idx = lfindIndex(parentRef.legoDolls ?? [], (ld) =>
        _idEquals(pathLast(path), ld.legoInstanceId)
      );
      if (idx == -1) {
        return new KitDollPlan({ kitDoll: c });
      }
      const removedItem = ocopy(parentRef.legoDolls[idx]);
      parentRef.legoDolls = lremoveAt(parentRef.legoDolls, idx);
      const del = {
        method: HttpMethod.DELETE,
        path: `kits/${c.kitId}/lego_instances/${removedItem.legoInstanceId}`,
        options: { orgPath: true },
      };
      const orderPatches = lenumerate(parentRef.legoDolls)
        .slice(idx)
        .map(([idx, ld]: [number, LegoDoll]) => ({
          method: HttpMethod.PATCH,
          path: `kits/${c.kitId}/lego_instances/${ld.legoInstanceId}`,
          body: { order: idx },
          options: { orgPath: true },
        }));
      return new KitDollPlan({
        kitDoll: c,
        parallelRequests: [del, ...orderPatches],
      });
    } else {
      let ancestorRef: KitDoll | null;
      let pathPartToDel: string;
      if (_isLeaf(pathLast(path))) {
        // if the path is to a leaf, and this is a kit that wraps another
        // kit (i.e. root is NOT a lego kit), then we want to delete the entire
        // kit instance, not the lego instance, so we actually need the grandparent
        ancestorRef = _getGrandparent(c, path, false);
        pathPartToDel = pathLast(pathChopLast(path));
      } else {
        ancestorRef = _getParent(c, path, false);
        pathPartToDel = pathLast(path);
      }
      if (ancestorRef === null || !ancestorRef.kitDolls) {
        return new KitDollPlan({ kitDoll: c });
      }
      const idx = lfindIndex(ancestorRef.kitDolls ?? [], (k) =>
        _idEquals(pathPartToDel, k.kitInstanceId)
      );
      if (idx == -1) {
        return new KitDollPlan({ kitDoll: c });
      }
      const removedItem = ocopy(ancestorRef.kitDolls[idx]);
      ancestorRef.kitDolls = lremoveAt(ancestorRef.kitDolls, idx);
      const del = {
        method: HttpMethod.DELETE,
        path: `kits/${c.kitId}/kit_instances/${removedItem.kitInstanceId}`,
        options: { orgPath: true },
      };
      console.log("removedItem", removedItem);
      const kiliDel = {
        method: HttpMethod.DELETE,
        path: `kits/kili/${removedItem.kitInstanceId}_${
          //@ts-ignore
          lfirst(removedItem.legoDolls).legoInstanceId
        }`,
        options: { orgPath: true },
      };
      const orderPatches = lenumerate(ancestorRef.kitDolls)
        .slice(idx)
        .map(([idx, k]: [number, KitDoll]) => ({
          method: HttpMethod.PATCH,
          path: `kits/${c.kitId}/kit_instances/${k.kitInstanceId}`,
          body: { order: idx },
          options: { orgPath: true },
        }));
      return new KitDollPlan({
        kitDoll: c,
        parallelRequests: [del, kiliDel, ...orderPatches],
      });
    }
  }
}
// // THIS WILL THROW AN ERROR
// // _planToRemove({ kitInstanceId: "root" }, "root"); //=
// _planToRemove({ kitInstanceId: "root" }, "nada"); //=
// // Remove lone LegoDoll from LegoKit with (no order patching)
// _planToRemove(
//   { kitInstanceId: "root", kitId: 7, legoDolls: [{ legoInstanceId: 123 }] },
//   "root.li_123"
// ); //=
// // Remove lone KitDoll from kit with (no order patching)
// _planToRemove(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     kitDolls: [{ kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] }],
//   },
//   "root.ki_456.li_123"
// ); //=
// // Order patching
// _planToRemove(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     kitDolls: [
//       { kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] },
//       { kitInstanceId: 111, legoDolls: [{ legoInstanceId: 222 }] },
//       { kitInstanceId: 999, legoDolls: [{ legoInstanceId: 444 }] },
//     ],
//   },
//   "root.ki_456.li_123"
// ).parallelRequests; //=
// // Path to kit doll
// _planToRemove(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     kitDolls: [
//       { kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] },
//       { kitInstanceId: 111, legoDolls: [{ legoInstanceId: 222 }] },
//       { kitInstanceId: 999, legoDolls: [{ legoInstanceId: 444 }] },
//     ],
//   },
//   "root.ki_456"
// ); //=

/*

 .d8888b.           888                                      
d88P  Y88b          888                                      
Y88b.               888                                      
 "Y888b.    .d8888b 88888b.   .d88b.  88888b.d88b.   8888b.  
    "Y88b. d88P"    888 "88b d8P  Y8b 888 "888 "88b     "88b 
      "888 888      888  888 88888888 888  888  888 .d888888 
Y88b  d88P Y88b.    888  888 Y8b.     888  888  888 888  888 
 "Y8888P"   "Y8888P 888  888  "Y8888  888  888  888 "Y888888 
                                                             
                                                             
                                                             

*/
function _planToUpdateSchemaElement(
  kd: KitDoll,
  element: KitRunSchemaElement,
  legoPath: string,
  elementPath: string,
  differentOrgId = "",
  kili = false,
  skipDB = false
): KitDollPlan {
  // somewhere in here
  const c = ocopy(kd) as KitDoll;
  const ref = _get(c, legoPath, false) as LegoDoll;
  if (ref === null) {
    return new KitDollPlan({ kitDoll: c });
  }
  ref.kitRunSchema = replaceElementInSchema(
    ref.kitRunSchema,
    elementPath,
    element
  );
  if (skipDB) {
    return new KitDollPlan({ kitDoll: c });
  }
  const parent = _getParent(c, legoPath) as KitDoll;
  const parallelRequests = [] as ApiRequest[];
  if (kili) {
    console.log("post to kili");
    console.log("ref.kitRunSchema:", ref.kitRunSchema);
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/kili/${parent.kitInstanceId}_${ref.legoInstanceId}`,
      body: {
        kiliSchema: schemaToStr(
          trimDownSchema(ref.kitRunSchema, {
            from: "kitrun",
            to: "instance",
          })
        ),
      },
      options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
    });
  } else {
    console.log("postToLi");
    console.log("ref.kitRunSchema:", ref.kitRunSchema);
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${parent.kitId}/lego_instances/${ref.legoInstanceId}`,
      body: {
        instanceParamSchema: schemaToStr(
          trimDownSchema(ref.kitRunSchema, {
            from: "kitrun",
            to: "instance",
          })
        ),
      },
      options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
    });
  }
  return new KitDollPlan({ kitDoll: c, parallelRequests: parallelRequests });
}

// _planToUpdateSchemaElement(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     legoDolls: [
//       {
//         legoInstanceId: 123,
//         kitRunSchema: [{ key: "name", value: "Jeremiah" }],
//       },
//     ],
//   },
//   { key: "name", value: "Jeffrey" },
//   "root.li_123",
//   "name"
// ).kitDoll.legoDolls[0]; //=

function _apiRequestForSchemaUpdate(
  legoDoll: LegoDoll,
  parent: KitDoll,
  kili: boolean | null,
  differentOrgId = ""
): ApiRequest {
  if (kili) {
    console.log("update KILI TABLE");
    console.log("does this schema have a paramSender:", legoDoll.kitRunSchema);
    return {
      method: HttpMethod.PATCH,
      path: `kits/kili/${parent.kitInstanceId}_${legoDoll.legoInstanceId}`,
      body: {
        kiliSchema: schemaToStr(
          trimDownSchema(legoDoll.kitRunSchema, {
            from: "kitrun",
            to: "instance",
          })
        ),
      },
      options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
    };
  } else {
    console.log("update LI TABLE");
    return {
      method: HttpMethod.PATCH,
      path: `kits/${parent.kitId}/lego_instances/${legoDoll.legoInstanceId}`,
      body: {
        instanceParamSchema: schemaToStr(
          trimDownSchema(legoDoll.kitRunSchema, {
            from: "kitrun",
            to: "instance",
          })
        ),
      },
      options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
    };
  }
}
function _planToUpdateSchema(
  kd: KitDoll,
  schema: KitRunSchemaElement[],
  legoPath: string,
  differentOrgId = "",
  kili = false as boolean | null,
  skipDB = false
): KitDollPlan {
  const c = ocopy(kd) as KitDoll;
  const ref = _get(c, legoPath, false) as LegoDoll;
  if (ref === null) {
    return new KitDollPlan({ kitDoll: c });
  }
  ref.kitRunSchema = schema;
  if (skipDB) {
    return new KitDollPlan({ kitDoll: c });
  }
  const parent = _getParent(c, legoPath) as KitDoll;
  // const parallelRequests = [];
  // if (kili) {
  //   console.log("update KILI TABLE");
  //   console.log("does this schema have a paramSender:", schema);
  //   parallelRequests.push({
  //     method: HttpMethod.POST,
  //     path: `kits/kili/${parent.kitInstanceId}_${ref.legoInstanceId}`,
  //     body: {
  //       kiliId: `${parent.kitInstanceId}_${ref.legoInstanceId}`,
  //       kitInstanceId: parent.kitInstanceId,
  //       legoInstanceId: ref.legoInstanceId,
  //       kiliSchema: schemaToStr(
  //         trimDownSchema(ref.kitRunSchema, {
  //           from: "kitrun",
  //           to: "instance",
  //         })
  //       ),
  //     },
  //     options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
  //   });
  // } else {
  //   console.log("update LI TABLE");
  //   parallelRequests.push({
  //     method: HttpMethod.PATCH,
  //     path: `kits/${parent.kitId}/lego_instances/${ref.legoInstanceId}`,
  //     body: {
  //       instanceParamSchema: schemaToStr(
  //         trimDownSchema(ref.kitRunSchema, {
  //           from: "kitrun",
  //           to: "instance",
  //         })
  //       ),
  //     },
  //     options: { orgPath: true, enforceOrder: true, orgId: differentOrgId },
  //   });
  // }
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: [
      _apiRequestForSchemaUpdate(ref, parent, kili, differentOrgId),
    ],
  });
}

/*

8888888                                    888    
  888                                      888    
  888                                      888    
  888   88888b.  .d8888b   .d88b.  888d888 888888 
  888   888 "88b 88K      d8P  Y8b 888P"   888    
  888   888  888 "Y8888b. 88888888 888     888    
  888   888  888      X88 Y8b.     888     Y88b.  
8888888 888  888  88888P'  "Y8888  888      "Y888 
                                                  
                                                  
                                                  

*/
// function _insertSender(
//   kd: KitDoll,
//   receiverPath: string,
//   sender: KitDoll | LegoDoll
// ): { kitDoll: KitDoll; path?: string } {
//   let receiverIdx;
//   let parentPath;

//   if (_rootIsLegoKit(kd)) {
//     // if ROOT is lego kit
//     const parent = _getParent(kd, receiverPath);
//     if (parent === null) {
//       return { kitDoll: kd };
//     }
//     receiverIdx = lfindIndex(parent.legoDolls ?? [], (ld) =>
//       _idEquals(pathLast(receiverPath), ld.legoInstanceId)
//     );
//     parentPath = pathChopLast(receiverPath);
//   } else {
//     const grandparent = _getGrandparent(kd, receiverPath);
//     if (grandparent === null) {
//       return { kitDoll: kd };
//     }
//     receiverIdx = lfindIndex(grandparent.kitDolls ?? [], (kd) =>
//       _idEquals(pathLast(pathChopLast(receiverPath)), kd.kitInstanceId)
//     );
//     parentPath = pathChopLast(pathChopLast(receiverPath));
//   }
//   return _insert(kd, parentPath, sender, receiverIdx);
// }
function _planToUpdateDirectory(kd: KitDoll, directoryId: number): KitDollPlan {
  const c = ocopy(kd) as KitDoll;
  const directoryPatch: ApiRequest = {
    method: HttpMethod.PATCH,
    path: `skinny-kits/${kd.kitId}`,
    body: { directoryId: directoryId },
    options: { orgPath: true },
  };
  c.directoryId = directoryId;
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: [directoryPatch],
  });
}
function _planToInsertSender(
  kd: KitDoll,
  receiverPath: string,
  senderKitId: number
): KitDollPlan {
  if (_rootIsLegoKit(kd)) {
    console.log("ROOT IS LEGO KIT");
    // if ROOT is lego kit
    const parent = _getParent(kd, receiverPath);
    if (parent === null) {
      return new KitDollPlan({ kitDoll: kd });
    }
    const receiverIdx = lfindIndex(parent.legoDolls ?? [], (ld) =>
      _idEquals(pathLast(receiverPath), ld.legoInstanceId)
    );
    const parentPath = pathChopLast(receiverPath);
    const orderPatches = lenumerate(parent.legoDolls ?? [])
      .slice(receiverIdx)
      .map(([idx, ld]: [number, LegoDoll]) => ({
        method: HttpMethod.PATCH,
        path: `kits/${kd.kitId}/lego_instances/${ld.legoInstanceId}`,
        body: { order: idx + 1 }, // need to bump up order because we haven't actually inserted yet
        options: { orgPath: true },
      }));
    const kdRequest = {
      method: HttpMethod.GET,
      path: `deep-kits/${senderKitId}`,
      options: { orgPath: true },
      callback: (getResp: EDeepKitGET) => {
        const anchor: EDeepKitGET_LegoInstance_2 | null = lfind(
          getResp.legoInstances,
          (li: EDeepKitGET_LegoInstance_2) => li.legoId === getResp.anchorLegoId
        );
        if (!anchor) {
          return kd;
        }
        return {
          method: HttpMethod.POST,
          path: `kits/${kd.kitId}/lego_instances`,
          body: {
            kitId: kd.kitId,
            olId: anchor.olId,
            orgId: anchor.orgId,
            legoId: anchor.legoId,
            instanceParamSchema: anchor.instanceParamSchema,
            order: receiverIdx,
            mostRecentRunId: null,
          },
          options: { orgPath: true },
          callback: (postResp: ELegoInstancePOSTResp) => {
            const { kitDoll, path } = _insert(
              // _insert makes a copy so as long as we don't mutate kd above, we're good
              kd,
              parentPath,
              _initLegoDoll(anchor, kd.kitInstanceId, postResp),
              receiverIdx
            );
            return {
              kitDoll: kitDoll,
              path: path,
            };
          },
        };
      },
    };
    return new KitDollPlan({
      kitDollRequest: kdRequest,
      parallelRequests: orderPatches,
    });
  } else {
    const grandparent = _getGrandparent(kd, receiverPath);
    if (grandparent === null) {
      return new KitDollPlan({ kitDoll: kd });
    }
    const receiverIdx = lfindIndex(grandparent.kitDolls ?? [], (kd) =>
      _idEquals(pathLast(pathChopLast(receiverPath)), kd.kitInstanceId)
    );
    const grandparentPath = pathChopLast(pathChopLast(receiverPath));
    const orderPatches = lenumerate(grandparent.kitDolls ?? [])
      .slice(receiverIdx)
      .map(([idx, kdoll]: [number, KitDoll]) => ({
        method: HttpMethod.PATCH,
        path: `kits/${kd.kitId}/kit_instances/${kdoll.kitInstanceId}`,
        body: { order: idx + 1 }, // need to bump up order because we haven't actually inserted yet
        options: { orgPath: true },
      }));
    const kdRequest = {
      method: HttpMethod.POST,
      path: `kits/${kd.kitId}/kit_instances`,
      body: {
        parentKitId: kd.kitId,
        childKitId: senderKitId,
        order: receiverIdx,
      },
      options: { orgPath: true },
      callback: (postResp: EKitInstancePOSTResp) => ({
        method: HttpMethod.GET,
        path: `deep-kits/${postResp.childKitId}`,
        options: { orgPath: true },
        callback: (getResp: EDeepKitGET) => {
          const { kitDoll, path } = _insert(
            // _insert makes a copy so as long as we don't mutate kd above, we're good
            kd,
            grandparentPath,
            _initKitDoll(getResp, postResp.kitInstanceId, postResp.order),
            receiverIdx
          );
          const anchor = _findFirstAnchorLego(
            _get(kitDoll, path ?? "") as KitDoll
          );
          console.log("anchor:", anchor);
          return {
            kitDoll: kitDoll,
            path: pathJoin(path ?? "", _dollToPathPart(anchor)),
            parallelRequests: [
              {
                method: HttpMethod.POST,
                //@ts-ignore
                path: `kits/kili/${postResp.kitInstanceId}_${anchor.legoInstanceId}`,
                body: {
                  kitId: kd.kitId,
                  kitInstanceId: postResp.kitInstanceId,
                  //@ts-ignore
                  legoInstanceId: anchor.legoInstanceId,
                  kiliSchema: schemaToStr(
                    //@ts-ignore
                    trimDownSchema(anchor.kitRunSchema, {
                      from: "kitrun",
                      to: "instance",
                    })
                  ),
                },
                options: { orgPath: true },
              },
            ],
          };
        },
      }),
    };
    return new KitDollPlan({
      kitDollRequest: kdRequest,
      parallelRequests: orderPatches,
    });
  }
}
function _planToAppendLegoKit(kd: KitDoll, childKitId: number): KitDollPlan {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/kit_instances`,
    body: {
      parentKitId: kd.kitId,
      childKitId: childKitId,
      order: kd.kitDolls?.length ?? 0,
    },
    options: { orgPath: true },
    callback: (postResp: EKitInstancePOSTResp) => ({
      method: HttpMethod.GET,
      path: `deep-kits/${postResp.childKitId}`,
      options: { orgPath: true },
      callback: (getResp: EDeepKitGET) => {
        const { kitDoll, path } = _insert(
          kd,
          "root",
          _initKitDoll(
            getResp,
            postResp.kitInstanceId,
            kd.kitDolls?.length ?? 0
          ),
          kd.kitDolls?.length ?? 0
        );
        const anchor = _findFirstAnchorLego(
          _get(kitDoll, path ?? "") as KitDoll
        );
        const newKitDoll = kitDoll.kitDolls?.find(
          (kd: KitDoll) => kd.kitInstanceId == postResp.kitInstanceId
        );
        return {
          kitDoll: kitDoll,
          path: pathJoin(path ?? "", _dollToPathPart(anchor)),
          parallelRequests: newKitDoll?.legoDolls?.map(
            (legoDoll: LegoDoll) => ({
              method: HttpMethod.POST,
              path: `kits/kili/${postResp.kitInstanceId}_${legoDoll.legoInstanceId}`,
              body: {
                kitId: kd.kitId,
                kitInstanceId: postResp.kitInstanceId,
                legoInstanceId: legoDoll.legoInstanceId,
                kiliSchema: schemaToStr(
                  trimDownSchema(legoDoll.kitRunSchema, {
                    from: "kitrun",
                    to: "instance",
                  })
                ),
              },
              options: { orgPath: true },
            })
          ),
        };
      },
    }),
  };
  return new KitDollPlan({ kitDollRequest: request });
}

function _insert(
  kd: KitDoll,
  pathToParent: string,
  item: KitDoll | LegoDoll,
  idx: number
): { kitDoll: KitDoll; path?: string } {
  const c = ocopy(kd) as KitDoll;
  const parentRef = _get(c, pathToParent, false) as KitDoll;
  if (parentRef === null) {
    return { kitDoll: c };
  }
  let insertedPath;
  console.log("ITEM IN _INSERT", item);
  if (_isLegoKit(parentRef)) {
    console.log("_INSERT: LegoKit");
    parentRef.legoDolls = lInsertAt(parentRef.legoDolls ?? [], idx, item);
    insertedPath = pathJoin(pathToParent, _dollToPathPart(item));
    for (let i = idx + 1; i < parentRef.legoDolls?.length; i++) {
      parentRef.legoDolls[i].order = i;
    }
  } else {
    console.log("_INSERT: NOT LegoKit");
    parentRef.kitDolls = lInsertAt(parentRef.kitDolls ?? [], idx, item);
    insertedPath = pathJoin(pathToParent, _dollToPathPart(item));
    for (let i = idx + 1; i < parentRef.kitDolls?.length; i++) {
      parentRef.kitDolls[i].order = i;
    }
  }
  return { kitDoll: c, path: insertedPath };
}

/*

888888b.            888    888                              
888  "88b           888    888                              
888  .88P           888    888                              
8888888K.  888  888 888888 888888 .d88b.  88888b.  .d8888b  
888  "Y88b 888  888 888    888   d88""88b 888 "88b 88K      
888    888 888  888 888    888   888  888 888  888 "Y8888b. 
888   d88P Y88b 888 Y88b.  Y88b. Y88..88P 888  888      X88 
8888888P"   "Y88888  "Y888  "Y888 "Y88P"  888  888  88888P' 
                                                            
                                                            
                                                            

*/

function _planToCreateButton(
  kd: KitDoll,
  name: string,
  color: string,
  senderKiliId: string,
  receiverKiliId: string
): KitDollPlan {
  const request = {
    method: HttpMethod.POST,
    path: `for_each_button`,
    body: {
      name,
      color,
      senderKiliId,
      receiverKiliId,
    },
    options: { orgPath: true },

    callback: (postResp: EForEachButtonPOSTResp) => {
      const sender = _getLego(kd, _kiliIdToPath(senderKiliId), false);
      let newKd = _setLego(kd, _kiliIdToPath(senderKiliId), {
        forEachButtonsOnOutput: lappend(
          sender?.forEachButtonsOnOutput ?? [],
          postResp
        ),
      });
      const receiver = _getLego(newKd, _kiliIdToPath(receiverKiliId), false);
      newKd = _setLego(newKd, _kiliIdToPath(receiverKiliId), {
        isHidden: true,
        forEachButtonsIsRecevier: lappend(
          receiver?.forEachButtonsIsRecevier ?? [],
          postResp
        ),
      });
      return { kitDoll: newKd };
    },
  };

  return new KitDollPlan({ kitDollRequest: request });
}

/*

888     888 d8b          d8b 888      d8b 888 d8b 888             
888     888 Y8P          Y8P 888      Y8P 888 Y8P 888             
888     888                  888          888     888             
Y88b   d88P 888 .d8888b  888 88888b.  888 888 888 888888 888  888 
 Y88b d88P  888 88K      888 888 "88b 888 888 888 888    888  888 
  Y88o88P   888 "Y8888b. 888 888  888 888 888 888 888    888  888 
   Y888P    888      X88 888 888 d88P 888 888 888 Y88b.  Y88b 888 
    Y8P     888  88888P' 888 88888P"  888 888 888  "Y888  "Y88888 
                                                              888 
                                                         Y8b d88P 
                                                          "Y88P"  
*/

function _planToUpdateVisibility(kd: KitDoll, visibility: KitVisibility) {
  const request = {
    method: HttpMethod.PATCH,
    path: `skinny-kits/${kd.kitId}`,
    body: { visibility: visibility },
    options: { orgPath: true },
  };
  const c = ocopy(kd) as KitDoll;
  c.visibility = visibility;

  return new KitDollPlan({ kitDoll: c, parallelRequests: [request] });
}

/*

 .d8888b.                           888                 888                                
d88P  Y88b                          888                 888                                
888    888                          888                 888                                
888        888d888 .d88b.   8888b.  888888 .d88b.       888      .d88b.   .d88b.   .d88b.  
888        888P"  d8P  Y8b     "88b 888   d8P  Y8b      888     d8P  Y8b d88P"88b d88""88b 
888    888 888    88888888 .d888888 888   88888888      888     88888888 888  888 888  888 
Y88b  d88P 888    Y8b.     888  888 Y88b. Y8b.          888     Y8b.     Y88b 888 Y88..88P 
 "Y8888P"  888     "Y8888  "Y888888  "Y888 "Y8888       88888888 "Y8888   "Y88888  "Y88P"  
                                                                              888          
                                                                         Y8b d88P          
                                                                          "Y88P"           
*/

function _planToCreateLego(
  kd: KitDoll,
  lego: Body_create_lego_v1__org_id__legos_post
) {
  const request = {
    method: HttpMethod.POST,
    path: "legos",
    body: lego,
    options: { orgPath: true },
    callback: (kitId: number) => {
      return _planToAppendLegoKit(kd, kitId).kitDollRequest;
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

export default {
  isEmpty: _isEmpty,
  getKitDollsForRender: _getKitDollsForRender,
  getAnchorLego: _getAnchorLego,
  getParent: _getParent,
  findAllWithPaths: _findAllWithPaths,
  findAllLegosWithPaths: _findAllLegosWithPaths,
  findAllReceivers: _findAllReceivers,
  findFirstAnchorLego: _findFirstAnchorLego,
  setLego: _setLego,
  isAnchorLego: _isAnchorLego,
  rootIsLegoKit: _rootIsLegoKit,
  pathPartToId: _pathPartToId,
  isLegoKit: _isLegoKit,
  kdLdToPath: _kdLdToPath,
  bindUrlParams: _bindUrlParams,
  addressAmbiguousParams: _addressAmbiguousParams,
  toQueryString: _toQueryString,
  toExcelFormula: _toExcelFormula,
  setDefaultValues: _setDefaultValues,
  elementSet: _elementSet,
  elementGet: _elementGet,
  initKitDoll: _initKitDoll,
  planToAppendLegoKit: _planToAppendLegoKit,
  hasSibling: _hasSibling,
  getSiblings: _getSiblings,
  getLego: _getLego,
  getKit: _getKit,
  getAllLegos: _getAllLegos,
  getAllLegosWithPaths: _getAllLegosWithPaths,
  canBeAutoRun: _canBeAutoRun,
  planToRemove: _planToRemove,
  planToUpdateLego: _planToUpdateLego,
  planToUpdateSchemaElement: _planToUpdateSchemaElement,
  planToUpdateSchema: _planToUpdateSchema,
  planToSync: _planToSync,
  planToInsertSender: _planToInsertSender,
  planToUpdateDirectory: _planToUpdateDirectory,
  initRecentKitDolls: _initRecentKitDolls,
  initSkinnyKits: _initSkinnyKits,
  collapseSenders: _collapseSenders,
  hideButtonSources: _hideButtonSources,
  buttonBlocksAreHidden: _buttonBlocksAreHidden,
  mapLegoKitQueryParamPathsToKingKitPaths: _mapLegoKitQueryParamPathsToKingKitPaths,
  planToCreateButton: _planToCreateButton,
  planToUpdateVisibility: _planToUpdateVisibility,
  planToCreateLego: _planToCreateLego,
};

// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math
